import { memo, useCallback, useState } from 'react';

import { Input, SectionForm, Spacer, SwitchInput, Textarea } from '@Sage/hoi-poi-ui';
import { isEqual } from '@Sage/ssm-utils';

import EmailInput from 'containers/components/Fields/EmailInput';
import { getLiteral } from 'utils/getLiteral';

import { validations } from '../validations';

const InformationSection = memo(({ form, onChange, onErrorChange }) => {
    const [errors, setErrors] = useState({});

    const handleChange = useCallback(
        (field) => (value) => {
            let newErrors = { ...errors };
            const validation = validations[field] || (() => {});
            const error = validation(value);

            if (error) {
                newErrors[field] = error;
            } else {
                delete newErrors[field];
            }

            setErrors(newErrors);
            if (!isEqual(newErrors, errors)) onErrorChange?.(newErrors);
            onChange(field, value);
        },
        [errors, onChange, onErrorChange],
    );

    return (
        <SectionForm title={getLiteral('label_information')}>
            <Input
                label={getLiteral('label_automation_name')}
                labelMode="vertical"
                placeholder={getLiteral('placeholder_text_field')}
                isRequired
                onChange={handleChange('name')}
                value={form?.name}
                error={errors?.name}
                autoFocus
                isFullWidth
            />
            <Textarea
                label={getLiteral('label_automation_description')}
                labelMode="vertical"
                placeholder={getLiteral('placeholder_text_field')}
                onChange={handleChange('description')}
                value={form?.description}
                error={errors?.description}
                minRows={4}
                maxRows={10}
                isFullWidth
            />
            <SwitchInput
                label={getLiteral('action_automations_notify_error')}
                onChange={handleChange('enabledErrorNotification')}
                isFullWidth
                value={form?.enabledErrorNotification}
            />

            {form?.enabledErrorNotification && (
                <>
                    <Spacer y={3} />
                    <EmailInput
                        label={getLiteral('label_automation_notify_error_email_to')}
                        placeholder={getLiteral('placeholder_search_hint')}
                        onChange={handleChange('notificationEmail')}
                        value={form?.notificationEmail}
                        isRequired
                        entityFilter="Usuario"
                        skipPermissions
                    />
                </>
            )}
        </SectionForm>
    );
});

export default InformationSection;
